
import React, {Component } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import './style.css'
import { LogoWhatsapp } from 'react-ionicons';
import {Card, CardHeader, CardBody} from 'reactstrap'
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import mountain from './assets/mountain.jpg'

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });
  

class Whatsappfields extends Component {

    constructor(props){

        super(props);

		this.state = {
            hierarchy: props.hierarchy || [], 
            orderdHierarchy: props.orderdHierarchy || [], 
            defaultValue: "", 
            sendData: false, 
            sentError: "", 
            curridx: 0,
            applicationsent: false,
            currimage: "", //for unsplash bg-picture
            
		};     

    }




    componentDidMount() {
        this.getUnsplashNewPhoto();
    }


    removeItems(id){
        
        this.state.hierarchy = this.state.hierarchy.filter(h => h.parentId!=id)
        
    }

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });


    InputFileUpload(props) {
        return (
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
          >
            Upload files
            <VisuallyHiddenInput
              type="file"
              onChange={(e) =>{ 
                props.obj.userdata = e.target.files

                console.log(e.target.files)}}
              multiple
            />
          </Button>
        );
      }


    myonKeyPressed(e,i) {

        console.log("key: ", e.key)
        if (e.key == "Enter"){
            let indexnew = 0
            let sd = this.state.sendData
            if (this.state.hierarchy.length > i+1){
                indexnew = i+1
            }else {
                sd = !sd
            }
            this.setState({curridx : indexnew, sendData: sd,   defaultValue: ""})
    
            this.getNextItem(this.state.curridx)
        }

    }
   


     getNextItem(ind){



        let retval = []
        let retvallist = []
        let np = {}
        let localidx = ind
        let firstoccuranceoflist = true
        let textInit = ""
     

        if (!this.state.hierarchy[ind].hasOwnProperty("answerType")){
            retval.push(<div className="styleh1" ><h1>{this.state.hierarchy[ind].value}</h1></div>)
        
            if (this.state.hierarchy[ind].hasOwnProperty("mediaUrl") && this.state.hierarchy[ind].mediaUrl){
                retval.push(
                    <div style={{marginBottom: "10px"}}>
<video width="40%"  controls>
<source src={this.state.hierarchy[ind].mediaUrl} type="video/mp4"/>
</video>

</div>
);
            }
            
            



            for (let i=ind+1; i<this.state.hierarchy.length; i++){
                if (this.state.hierarchy[i].parentId == this.state.hierarchy[ind].id){
                    if (this.state.hierarchy[i].hasOwnProperty("answerType")){
                        if (this.state.hierarchy[i].answerType == "text"){
                            
                            retval.push(<div key={this.state.hierarchy[i].id} style={{ display: "flex", alignItems: "center", justifyContent: "center",  gap: "10px"}}>
                                
                                <TextField autoFocus onKeyDown={(e) => this.myonKeyPressed(e, i)} label={this.state.hierarchy[i].value} defaultValue={this.state.hierarchy[i].hasOwnProperty("userdata")? this.state.hierarchy[i].userdata : ""} size="small" onChange={(e) => {
                                    
                                    this.state.hierarchy[i].userdata = e.target.value
                                    console.log("retval is: ", this.state.hierarchy)


                                }} /><Button variant="contained"   onClick={() => {
                                    let indexnew = 0
                                    let sd = this.state.sendData
                                    if (this.state.hierarchy.length > i+1){
                                        indexnew = i+1
                                    }else {
                                        sd = !sd
                                    }
                                    this.setState({curridx : indexnew, sendData: sd,   defaultValue: ""})}}>weiter</Button>
                                </div>)

                            
                        }

                        if (this.state.hierarchy[i].answerType == "upload"){
                            retval.push(<div style={{ display: "flex", alignItems: "center", justifyContent: "center",  gap: "10px"}}>
                                <this.InputFileUpload obj={this.state.hierarchy[i]}   /><Button variant="contained"   onClick={() => 
                                    {
                                        let indexnew = 0
                                        let sd = this.state.sendData
                                        if (this.state.hierarchy.length > i+1){
                                            indexnew = i+1
                                        }else {
                                            sd = !sd
                                        }
                                        this.setState({curridx : indexnew, sendData: sd,   defaultValue: ""})}}>weiter</Button>
                                </div>)

                            
                        }                
                        
                        if (this.state.hierarchy[i].answerType == "list" ){


                            //retvallist.push(this.state.hierarchy[i])
                            retval.push(
                            <div>
                        <input type="radio" value={this.state.hierarchy[i].value} id={this.state.hierarchy[i].id} name={this.state.hierarchy[i].parentId}  onChange={(e)=> 
                            {
                            //first remove all userclicks and then add it to current clicked radio-box
                            let additionalcount = 0;
                            for (let li=0;li <this.state.hierarchy.length; li++){
                                if (this.state.hierarchy[li].hasOwnProperty("answerType") && this.state.hierarchy[li].answerType=="list" && this.state.hierarchy[li].parentId==this.state.hierarchy[ind].id){
                                    console.log("remove item ", this.state.hierarchy[li].id)
                                    delete this.state.hierarchy[li].userdata;
                                    additionalcount++;
                                }
                            }
                            this.state.hierarchy[i].userdata=e.target.checked
                            console.log("retval is: ", this.state.hierarchy)
                            let indexnew = 0
                            let sd = this.state.sendData

                            let lastQuestion = this.state.hierarchy[this.state.hierarchy.length-1].hasOwnProperty("parentId") && this.state.hierarchy[this.state.hierarchy.length-1].parentId == this.state.hierarchy[i].parentId ? true : false

                            if (!lastQuestion) {
                                console.log("ind is: ", ind)
                                console.log("addcount is ",additionalcount)
                                indexnew = ind + additionalcount+1;
                                
                                //indexnew = i; 
                                sd=false}
                            else sd=true

                            
                            this.setState({curridx : indexnew, sendData: sd})                            
                        
                        }
                            
                        }
                            />
                        <label htmlFor={this.state.hierarchy[i].value}>{this.state.hierarchy[i].value}</label>




                        </div>
                            )
                        
                            
                        }                           

                        if (this.state.hierarchy[i].answerType == "button"){
                            retval.push( <Button  style={{ marginRight:"10px"}} variant="contained" onClick={(e) => {
                                let cidxmap = this.state.hierarchy.map((h, idx) => {
                                    if (h.parentId == this.state.hierarchy[i].id)
                                        return idx;
                                    })
                                    


                                    cidxmap = cidxmap.filter(Boolean)
                                    let cidx = 0
                                    if (cidxmap.length > 0) // child was found
                                    cidx = cidxmap[0]
                                    else{ // cidx = 0

                                        for (let locali = i; locali<this.state.hierarchy.length; locali++){
                                            if (!this.state.hierarchy[locali].hasOwnProperty("parentId")){
                                                cidx = locali;
                                                break;
                                            }
                                        }
                                        


                                    }


                                    for (let li=0;li <this.state.hierarchy.length; li++){
                                        if (this.state.hierarchy[li].hasOwnProperty("answerType") && this.state.hierarchy[li].answerType=="button" && this.state.hierarchy[li].parentId==this.state.hierarchy[ind].id){
                                            console.log("remove item ", this.state.hierarchy[li].id)
                                            delete this.state.hierarchy[li].userdata;
                                        }
                                    }

                                    this.state.hierarchy[i].userdata=true
                                    console.log("retval is: ", this.state.hierarchy)


                                    this.setState({curridx:cidx, sendData: cidx==0? true : false})
                            }}>{this.state.hierarchy[i].value}</Button>)

                        }

                    }
                }
           }

           
           
  
        
        }



        return retval;

    }

    

    getApplicationData() {

        let ret =  this.state.hierarchy.map( h => {
            if (h.hasOwnProperty("answerType") && h.hasOwnProperty("userdata")){
                let ud = h.userdata
                if (h.answerType == "button" || h.answerType =="list" ){
                    ud = this.state.hierarchy.find( f => f.id == h.parentId).value
                    return <p>{ud} : {h.value}</p>
                }

                if (h.answerType == "text"){
                    ud = this.state.hierarchy.find( f => f.id == h.parentId).value
                    return <p>{ud} : {h.userdata}</p>
                }

                if (h.answerType == "upload" ){
                    
                    ud = this.state.hierarchy.find( f => f.id == h.parentId).value
                    return <p>{ud} : {h.userdata[0].name}</p>                    
                }
                return <p>{h.value} : {ud}</p>
            }
        })

       // console.log("Retval is: ", ret)
        return ret;
    }



    async postUrl(url, waid, xfileupload, media ) {
        var request = require('superagent');
        let self = this
        console.log("url in posturl is: ",url+xfileupload.uuid+"/upload" )
        return new Promise( (resolve, reject) => {
          request.post(url+waid+"/upload")              
              .set('X-File-Upload', JSON.stringify(xfileupload))
              .attach('uploaded_media', media)
              .end(function (err, res) {
              if (err) {
                console.log("error ocurred");
                return
              }
              console.log("res", res);
              resolve(res)
            })
        
          
             
        })
    
    
    
      }
    


    async sendApplicationData(){

    let uuid = crypto.randomUUID()
    
    
    let entries = await Promise.all( this.state.hierarchy.map( async entry => {

        
            if (entry.hasOwnProperty("userdata") && entry.answerType == "upload"){
                //entry.userdata = {name: entry.userdata[0].name}
                let e = entry.userdata
                delete entry.userdata
                await Promise.resolve(  this.postUrl("https://api2-demo.joobster.at/external/webapp/", this.props.wacode, { id: entry.id, uuid}, e[0]))
            }
           if (entry.hasOwnProperty("userdata") && entry.answerType == "button"){
                entry.userdata = entry.userdata.toString()
            }
            if (entry.hasOwnProperty("userdata") && entry.answerType == "list"){
                entry.userdata = entry.userdata.toString()
            }            

            return entry
        }))

        console.log("Entries to post: ", entries)



      
          fetch("https://api2-demo.joobster.at/external/webapp/"+this.props.wacode, {
      
                  method: 'POST',
                  header: {
                    uuid
                  }, 
                  body: JSON.stringify(entries)
              })
              .then((response) => response.json())
              .then((response) => {

                console.log("response", response)
                if (response.status == "ok"){
                    this.setState({applicationsent: true, sentError: ""})

                }else {
                    this.setState({ applicationsent: true, sentError: response.hasOwnProperty("code") ? response.code : "Kein Attribut code vorhanden!"})
                }
              });
      
              



    }

    /*
    getNextChilds(parent){

        let retVal = [];

        for (let i=0; i<this.state.hierarchy.length; i++){
            let curritem = this.state.hierarchy[i]
            if (parent.id == curritem.parentId){

                if (curritem.hasOwnProperty("answerType")){

                    if (curritem.answerType=="button"){
                        retVal.push(<button >{curritem.value}</button>)
                    }else if (curritem.answerType=="text"){
                        retVal.push(<input type="text" />)
                    }

                }
                else retVal.push(<div>{curritem.value}</div>)
            }
        }

        return retVal;

    }

    */
    closeTab = () => {
        window.opener = null;
        window.open("", "_self");
        window.close();
      };

    

      async getUnsplashNewPhoto(){

        let header = new Headers({
          "Authorization" : "Client-ID 7aGa1NpT2R74tR9FkSgTZsYTE3V_ra9UeTL8xWpR3ZQ", 
          "topics" : "Nature", 
          "orientation" : "landscape"
    
    });
    
        fetch("https://api.unsplash.com/photos/random/?fit=clip&w=0.5&h=0.5&orientation=landscape&topics=nature", {
    
                method: 'GET',
                headers: header,            
            })
            .then((response) => response.json())
            .then((response) => {
              this.setState({
              currimage : response.urls.regular
            })
              console.log("response", response)
            });
    
      
        
      }
    


    render() {

        const {t} = this.props
        const localthis = this



    
      return (
        <div >
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css" integrity="sha384-WskhaSGFgHYWDcbwN70/dfYBj47jz9qbsMId/iRN3ewGhXQFZCSftd1LZCfmhktB" crossorigin="anonymous" />
    


              <section id="hero">

              <div style={{ backgroundImage: `url('${this.state.currimage || mountain}')`, backgroundRepeat: "no-Repeat",  backgroundSize: "cover",  textAlign: "center", backgroundPosition: "center"}}>                         

              <div className="container">


                      <div className="row align-items-center justify-content-center">
                                 <div style={{ display: "flex", height: 150,  justifyContent: "center", alignItems: "center"}}>
                                  <a href={`http://${this.props.company.websiteUri}`}>
                                      <img  src={this.props.company.logoUri} className="img-fluid" width={"160px"} alt="Missing image" />

                                  </a>
                                  </div>
                              </div>
                              

                      </div>

                  </div>
              </section>

{
    !this.state.applicationsent ? 
<>

  <Box justifyContent="center" alignItems="center" display="flex" >
      <Typography sx={{ fontWeight:600 }} variant="h2"  gutterBottom marginTop={2}  >
        Bewerbung {this.props.whatsapp.name}
      </Typography>

    </Box>


  <Divider/>
  <div style={{padding: "30px"}}></div>

{
    this.state.sendData ? 
    <div style={{paddingLeft: "5%", paddingRight: "5%", paddingBottom: "5%"}}>
    <Card >
        <CardHeader>
        <Button autoFocus variant="contained" onClick={() => {
            this.sendApplicationData()
            
        }} >Bewerbung absenden!</Button>
        </CardHeader>
        <CardBody>
        {this.getApplicationData()}
        </CardBody>
    </Card>
    </div>
    : null
}

<div style={{minHeight: "40vh"}}>
            {

                this.state.hierarchy.length > 0 ? 
<>

                {
                    this.getNextItem(this.state.curridx)
                    
                }
                </>
                
                : null
            }
</div>

</> : <>

{this.state.sentError ? 
<div><h3>
Fehlercode: {this.state.sentError}. </h3>
<p>Fehler beim Senden Ihrer Bewerbung. Bitte überprüfen Sie Ihr Internet, sollte der Fehler erneut auftreten senden Sie uns gerne eine Email mit Ihrem Fehlercode an hello@joobster.at.</p>

</div>
:
<div style={{display: "flex", minHeight:"40vh"}}> <Box justifyContent="center" alignItems="center" display="flex" >
      <Typography sx={{ fontWeight:600 }} variant="h1"  gutterBottom marginTop={2}  >
        Danke für die Bewerbung. Wir melden uns in Kürze!
      </Typography>

    </Box>
    </div>
    }
    </>

    }

<div style={{padding: "30px"}}></div>
<footer>
    <div className="container">
    <div className="row">
        <div className="col-md-12 col-xs-12">
            <a href={this.props.whatsapp.deepLink}><LogoWhatsapp color="white" beat style={{verticalAlign:"middle"}} /> Alternative Bewerbung über WhatsAPP</a>            
          </div>
          </div>
      
      <div className="divider"></div>
      <div className="row">
          <div className="col-md-12 col-xs-12">
            <small>{new Date().getFullYear()} &copy; Alle Rechte vorberhalten. <a href="https://www.joobster.at" target="_blank" style={{ color:"#fff"}}>joobster GmbH Software</a>.</small>
          </div>
      </div>
    </div>
  </footer>


        </div>
      );
}
}

export default Whatsappfields;
